// QR pictures, made by qrcodejs 1.0.0 (loaded by index.html as window.QRCode, the same file the labels always used).
// The library draws into an off-screen box; the picture is copied out as a data URL. Ported unchanged from the original pages.
import { cleanQrText } from './common';

interface QRCodeLib { new (el: HTMLElement, opts: Record<string, unknown>): unknown; CorrectLevel: { M: number } }
declare global { interface Window { QRCode?: QRCodeLib } }

const _qrCache: Record<string, string | null> = {};

export const qrSize = (labelW: number, labelH: number) => Math.round(Math.min(labelH * 0.375, labelW * 0.225));

export async function generateQR(scratch: HTMLElement, text: string, px: number): Promise<string | null> {
  const cleanText = cleanQrText(text);
  const key = cleanText + '|' + px;
  if(_qrCache[key]) return _qrCache[key];
  return new Promise(resolve => {
    const QRCode = window.QRCode;
    scratch.innerHTML = '';
    try{
      if(!QRCode) throw new Error('QR library not loaded');
      new QRCode(scratch, {
        text: cleanText, width:px, height:px,
        colorDark:'#000', colorLight:'#fff',
        correctLevel: QRCode.CorrectLevel.M
      });
    }catch{ resolve(null); return; }
    setTimeout(() => {
      const cv = scratch.querySelector('canvas');
      const im = scratch.querySelector('img');
      let src: string | null = null;
      if(cv) src = cv.toDataURL();
      else if(im) src = im.src;
      _qrCache[key] = src;
      resolve(src);
    }, 150);
  });
}
